<script setup>
import { computed } from 'vue'

const props = defineProps({
  versions: {
    type: Array,
    required: true,
  },
  attribute: {
    type: String,
    required: true,
  },
  formatter: {
    type: Function,
    default: null,
  },
})

const leftVersion = computed(() => props.versions[0])
const rightVersion = computed(() => props.versions[1] ?? null)
const comparingVersions = computed(() => !!(leftVersion.value && rightVersion.value))

const changed = computed(() => {
  if (!comparingVersions.value) {
    return false
  }

  return leftVersion.value[props.attribute] !== rightVersion.value[props.attribute]
})

const render = (attribute) => {
  if (props.formatter) {
    return props.formatter(attribute)
  }

  return attribute
}
</script>

<template>
  <slot :changed="changed">
    <div v-if="comparingVersions && changed" class="space-x-2">
      <span class="bg-green-50 text-green-700">
        {{ render(leftVersion[attribute]) }}
      </span>
      <span class="bg-red-50 text-red-400 line-through">
        {{ render(rightVersion[attribute]) }}
      </span>
    </div>

    <span v-else>
      {{ render(leftVersion[attribute]) }}
    </span>
  </slot>
</template>
